module.exports = __webpack_public_path__ + "img/rate.11872d29.svg";